import * as types from 'actions/actionTypes';
import * as services from 'services/apis/calAmp/entityServices';
import {beginAjaxCall, ajaxCallError} from './ajaxStatusActions';

export function getSystemUnitsRequest(){
    return {type: types.GET_SYSTEMUNITS_REQUEST}
}

export function getSystemUnitsSuccess(data){
    return {type: types.GET_SYSTEMUNITS_SUCCESS, data}
}

export function getSystemUnitsError(){
    return {type: types.GET_SYSTEMUNITS_ERROR}
}

/**
 * ricerca unità di misura
 * @param {nome dell'unità di misura} name
 */
export const getSystemUnits = (name) => dispatch => {
    /*\\
        notifico che sta partendo la richiesta
    */
    dispatch(getSystemUnitsRequest());
    dispatch(beginAjaxCall());

    // restituisce una promise
    services.getSystemUnits(name)

        .then(response => {
            /*
                operazione avvenuta con successo
            */
            var isMilesPerHour = false;

            var data = {
                isMilesPerHour: isMilesPerHour,
                speedUnitOfMeasure:''
            }

            for(var i=0;i<response.data.response.results.length;i++){
                var item = response.data.response.results[i].quantity;
                if(item.name === "Speed")
                {
                    data.isMilesPerHour = (item.unit === "mi/h" || item.unit === "mph" || item.unit === "miph");
                    data.speedUnitOfMeasure = item.unit;
                    break;
                }
            }

            dispatch(getSystemUnitsSuccess(data));
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(getSystemUnitsError());
    });
}


// WEBPACK FOOTER //
// ./src/actions/systemUnitsActions.js